import handleCondition from "./handleConditionOnQuestion";
import * as yup from 'yup';
import { isValidPhoneNumber } from "react-phone-number-input/max";

function getYupObjectPerQuestion(form, formData, question, t) {
    var schema = {};
    if ((question.fieldType !== "custom input" && question.fieldType !== "custom variable") && handleCondition(formData, question, form) && question.subfieldType !== "url") {
        switch (question.type) {
            case "string":
                if (question.fieldType === "date") {
                    var dateMin = new Date(new Date().getFullYear() - 1000, new Date().getMonth(), new Date().getDate());
                    var dateMax = question.name.includes("naissance") ? new Date(new Date().getFullYear() - 16, new Date().getMonth() + 1, new Date().getDate()) : new Date(new Date().getFullYear() + 1000, new Date().getMonth() + 1, new Date().getDate());
                    schema[question.name] = yup.date()
                        .test('date-year-min', t("DateBefore", { date : dateMin.toISOString().split('T')[0] }), function () {
                            const raw = this.originalValue;
                            if (!raw) return true;
                            const day = parseInt(String(raw).split('-')[2], 10);
                            const month = parseInt(String(raw).split('-')[1], 10);
                            const year = parseInt(String(raw).split('-')[0], 10);
                            var monthValid = year === dateMin.getFullYear() ? (!isNaN(month) && month >= dateMin.getMonth() && month <= 12) : !isNaN(month) && month >= 1 && month <= 12;
                            var dayValid = year === dateMin.getFullYear() && month === dateMin.getMonth() ? (!isNaN(day) && day >= dateMin.getDate() && day <= 31) : !isNaN(day) && day >= 1 && day <= 31;
                            return !isNaN(year) && year >= dateMin.getFullYear() && monthValid && dayValid;
                        })
                        .test('date-year-max', t("DateAfter", { date : dateMax.toISOString().split('T')[0] }), function () {
                            const raw = this.originalValue;
                            if (!raw) return true;
                            const day = parseInt(String(raw).split('-')[2], 10);
                            const month = parseInt(String(raw).split('-')[1], 10);
                            const year = parseInt(String(raw).split('-')[0], 10);
                            var monthValid = year === dateMax.getFullYear() ? (!isNaN(month) && month >= 1 && month <= dateMax.getMonth()) : !isNaN(month) && month >= 1 && month <= 12;
                            var dayValid = year === dateMax.getFullYear() && month === dateMax.getMonth() ? (!isNaN(day) && day >= 1 && day <= dateMax.getDate()) : !isNaN(day) && day >= 1 && day <= 31;
                            return !isNaN(year) && year <= dateMax.getFullYear() && monthValid && dayValid;
                        });
                } else {
                    schema[question.name] = yup.string();
                }
                break;
            case "array":
                schema[question.name] = yup.array();
                break;
            case "number":
                schema[question.name] = yup.number();
                break;
            case "bool":
                schema[question.name] = yup.boolean();
                break;
            default:
                schema[question.name] = yup.mixed();
                break;
        }
        if (question.min && question.fieldType !== "date") {
            schema[question.name] = schema[question.name].min(question.min)
        }
        if (question.max) {
            schema[question.name] = schema[question.name].max(question.max)
        }
        if (!question.readOnly && question.required) {
            schema[question.name] = schema[question.name].required(x => t("Required field", { questionName: question.label }))
        } else {
            schema[question.name] = schema[question.name].nullable()
        }
        if (question.subQuestions) {
            question.subQuestions.forEach(sb => {
                var generatedSchema = getYupObjectPerQuestion(form, formData, sb, t);
                Object.keys(generatedSchema).forEach(key => {
                    schema[key] = generatedSchema[key];
                })
            })
        }
        if (question.fieldType.includes("phone"))  {
            schema[question.name] = schema[question.name].test(
                'phone-validation',
                t("Numéro de téléphone invalide"),
                function(value) {
                    if (!value || value === '') return true;
                    return isValidPhoneNumber(value);
                }
            )
        }
        if (isRegex(question.subfieldType)) {
            schema[question.name] = schema[question.name].test(
                'regex-validation',
                t("Invalid format field") + ` (${question.label || question.name})`,
                function(value) {
                    if (!value || value === '') return true;
                    return new RegExp(question.subfieldType).test(value);
                }
            )
        }
    }
    return schema;
}

function getYupObject(form, formData, t) {
    var schema = {};
    form.forEach(question => {
        var generatedSchema = getYupObjectPerQuestion(form, formData, question, t);
        Object.keys(generatedSchema).forEach(key => {
            schema[key] = generatedSchema[key];
        })
    });
    return yup.object(schema);
}

function isRegex(value) {
    if (value && value.length > 0 && value !== "phone" && value !== "default")
        return new RegExp(value) instanceof RegExp;
    return false;
}

export default getYupObject;